import React from "react";
import PropTypes from 'prop-types';

import HttpStatusIcon from "shared/react_components/HttpStatusIcon";
import FormattedDate from "shared/react_components/FormattedDate";

export default function WebhookStats({
  fireStats,
  lastStatusCode,
  lastFiredAt,
  lastProcessedId,
  lastFailedId,
  lastFailedAt,
  lastFailureResponse
}) {
  return (
    <div data-test-selector="webhook-stats" className="w-100">
      <div className="row margin_bottom_default">
        <p data-id="fire_stats_label" className="col-5 d-inline-block mb-none">Fire Stats:</p>
        <p data-id="fire_stats_content" className="col-7 d-inline-block mb-none">
          {fireStats}
        </p>
      </div>
      <div className="row margin_bottom_default">
        <p data-id="last_status_code_label" className="col-5 d-inline-block mb-none">Last Status Code:</p>
        <p data-id="last_status_code_content" className="col-7 d-inline-block mb-none align-text-center d-flex">
          {lastStatusCode ? <><HttpStatusIcon statusCode={lastStatusCode} />{lastStatusCode}</> : <>&mdash;</>}
        </p>
      </div>
      <div className="row margin_bottom_default">
        <p data-id="last_fired_label" className="col-5 d-inline-block mb-none">Last Fired At:</p>
        <p data-id="last_fired_content" className="col-7 d-inline-block mb-none">
          <FormattedDate date={lastFiredAt}/>
        </p>
      </div>
      <div className="row margin_bottom_default">
        <p data-id="last_processed_transaction_id_label" className="col-5 d-inline-block mb-none">Last Transaction ID
          Processed:</p>
        <p data-id="last_processed_transaction_id_content" className="col-7 d-inline-block mb-none">
          {lastProcessedId}
        </p>
      </div>
      <div className="row margin_bottom_default">
        <p data-id="last_failed_transaction_id_label" className="col-5 d-inline-block mb-none">Last Failed Transaction ID:</p>
        <p data-id="last_failed_transaction_id_content" className="col-7 d-inline-block mb-none">
          {lastFailedId}
        </p>
      </div>
      <div className="row margin_bottom_default">
        <p data-id="last_failed_at_label" className="col-5 d-inline-block mb-none">Last Failed At:</p>
        <p data-id="last_failed_at_content" className="col-7 d-inline-block mb-none">
          <FormattedDate date={lastFailedAt}/>
        </p>
      </div>
      <div className="row">
        <p data-id="last_failure_response_label" className="col-5 d-inline-block mb-none">Last Failed Response Body:</p>
        <p data-id="last_failure_response_content" style={{ wordBreak: 'break-all' }} className="col-7 d-inline-block mb-none">
          {lastFailureResponse}
        </p>
      </div>
    </div>
  );
}

WebhookStats.propTypes = {
  fireStats: PropTypes.string,
  lastStatusCode: PropTypes.string,
  lastFiredAt: PropTypes.string,
  lastProcessedId: PropTypes.string,
  lastFailedId: PropTypes.string,
  lastFailedAt: PropTypes.string,
  lastFailureResponse: PropTypes.string
};
